// extracted by mini-css-extract-plugin
module.exports = {"tabWrapper":"TabNavigation_tabWrapper__2qgVw","selected":"TabNavigation_selected__3WzSf","subtab":"TabNavigation_subtab__OTNpl"};